export const PROPOSAL_CANCEL = 'proposal/cancel'
